import InnerComponent from '@Components/Inventory/DeliveryChallan/ViewDeliveryChallan';
import orgContainer from '@Components/AppContainer';

const ViewDeliveryChallan = () => ((orgContainer(InnerComponent)));
export default ViewDeliveryChallan;
